import { RootState } from 'app/store';

export const selectShowSidebar = (state: RootState) =>
  state.sidebar.showSidebar;
export const selectSidebarContentId = (state: RootState) =>
  state.sidebar.contentId;
export const selectActiveUserId = (state: RootState) =>
  state.sidebar.activeUserId;
export const selectIsBlockSidebarUrlHandling = (state: RootState) =>
  state.sidebar.isBlockUrlHandling;
